import React from 'react';
import { motion } from 'framer-motion';
import { MockupBook } from '../ui/MockupBook';
type BonusColor = 'terracota' | 'salvia' | 'dorado' | 'oscuro';
interface BonusItem {
  num: number;
  icon: string;
  title: string;
  color: BonusColor;
}
const BONUSES: BonusItem[] = [{
  num: 1,
  icon: '🕯️',
  title: '30 Rituales de Apertura y Cierre',
  color: 'salvia'
}, {
  num: 2,
  icon: '🎵',
  title: 'Guía de Música para tus Clases',
  color: 'terracota'
}, {
  num: 3,
  icon: '🙌',
  title: 'Guía de Ajustes y Asistencias',
  color: 'dorado'
}, {
  num: 4,
  icon: '📱',
  title: '60 Captions de Instagram',
  color: 'oscuro'
}, {
  num: 5,
  icon: '📓',
  title: 'Tracker Anual del Profesor',
  color: 'salvia'
}];
export function Bonus() {
  return <section className="py-16 md:py-24 px-4 bg-hueso" data-id="element-34" data-mp="2hylft6uxuf8w">
      <div className="max-w-3xl mx-auto" data-id="element-35" data-mp="2cyh1nnhi5wlu">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-36" data-mp="2cx5wbj8esgsm">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-4xl md:text-6xl font-bold text-oscuro mb-3 flex items-center justify-center gap-3" data-id="element-37" data-mp="2bo4hzct8a4dm">
            <span aria-hidden="true" data-id="element-38" data-mp="1sxmq1ag7zctb">🎁</span> 5 Bonos Exclusivos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-500 font-medium" data-id="element-39" data-mp="1xov2kfcujeap">
            Valorados en{' '}
            <span className="text-terracota line-through" data-id="element-40" data-mp="1exbye5735u73">$95 USD</span> —
            Incluidos <span className="text-salvia font-bold" data-id="element-41" data-mp="3gnswyuf1q1xx">GRATIS</span>
          </motion.p>
        </div>

        {/* Bonus rows */}
        <div className="space-y-5" data-id="element-42" data-mp="3bw16skzsxy8b">
          {BONUSES.map((bonus, idx) => <motion.div key={bonus.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="bg-white rounded-3xl shadow-soft p-5 md:p-6 flex items-center gap-4 md:gap-6" data-id="element-43" data-mp="37ufsqwbj7dwj" data-mpi={idx}>
              {/* Number badge */}
              <span className="flex-shrink-0 w-9 h-9 md:w-11 md:h-11 rounded-full bg-verdeOscuro text-white font-bold text-base md:text-lg flex items-center justify-center" data-id="element-44" data-mp="3loqct0cl2jw9">
                {bonus.num}
              </span>

              {/* Cover mockup */}
              <div className="flex-shrink-0" data-id="element-45" data-mp="204larhtoc7sp">
                <MockupBook title={`Bonus ${bonus.num}`} color={bonus.color} size="sm" icon={<span className="text-xl" data-id="element-47" data-mp="2a0omnfebvksu">{bonus.icon}</span>} data-id="element-46" data-mp="201pdzwtkbp5u" />
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0" data-id="element-48" data-mp="2etr7mz51hlxf">
                <h3 className="font-serif text-lg md:text-2xl font-bold text-oscuro leading-tight mb-1.5" data-id="element-49" data-mp="2iujh9thtpsu8">
                  {bonus.title}
                </h3>
                <p className="text-sm md:text-base font-bold" data-id="element-50" data-mp="2nv7jzcfezy4a">
                  <span className="text-terracota line-through mr-2" data-id="element-51" data-mp="2st8yrl5t5b9y">$19</span>
                  <span className="text-salvia uppercase tracking-wide" data-id="element-52" data-mp="2xru05nwsq0zz">
                    Gratis
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}